import BaseModel from './BaseModel';
import MultiLanguageDesignationModel from './MultiLanguageDesignationModel';
import * as AT from '../../components/container/attributes';
import {HitOnlineEnums} from 'hit-online-web-ui/src/helpers/constants';
import {translate} from '../../plugins/i18n/i18n';

export default class ResourceClassification extends MultiLanguageDesignationModel {
  constructor({
    id,
    number,
    designationFrBe = undefined,
    designationDeBe = undefined,
    designationNlBe = undefined,
    designationFrLu = undefined,
    designationDeLu = undefined,
    designationFrFr = undefined,
    designationDeDe = undefined,
    designationNlNl = undefined,
    designationEnGb = undefined,
    designationEnIn = undefined,
    designationMrIn = undefined,
    designationHiIn = undefined,
    classificationType = undefined,
    titleLevel = undefined,
  }) {
    super({
      id,
      number,
      designationFrBe,
      designationDeBe,
      designationNlBe,
      designationFrLu,
      designationDeLu,
      designationFrFr,
      designationDeDe,
      designationNlNl,
      designationEnGb,
      designationEnIn,
      designationMrIn,
      designationHiIn,
    });
    this.classificationType = classificationType
      ? HitOnlineEnums.getEnumValue(
          'RESOURCE_CLASSIFICATION',
          classificationType,
          translate,
        )
      : null;
    this.titleLevel = titleLevel;
  }
  static get fkName() {
    return 'resource_classification_id';
  }
  static get apiRoute() {
    return 'resource_classification';
  }
  static get listPageRoute() {
    return 'resourceClassificationList';
  }
  static get detailPageRoute() {
    return 'resourceClassificationList';
  }
  static get createInitColumns() {
    return {};
  }
  static get config() {
    const config = BaseModel.config;
    config['addable'] = false;
    return config;
  }
  get fkName() {
    return ResourceClassification.fkName;
  }
  get apiRoute() {
    return ResourceClassification.apiRoute;
  }
  get detailPageRoute() {
    return ResourceClassification.detailPageRoute;
  }
  get listPageRoute() {
    return ResourceClassification.listPageRoute;
  }
  get config() {
    return ResourceClassification.config;
  }

  static get orderKeyEmbedded() {
    return 'number';
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(
      [
        'classificationType',
        'number',
        this.attributeUserLocale('designation'),
        this.attributeCompanyLocale('designation'),
      ],
      ['titleLevel'],
    );
  }

  static get joinAttrsKey() {
    return [
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'classificationType',
      'titleLevel',
    ];
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes(
      [
        'classificationType',
        'number',
        this.attributeCompanyLocale('designation'),
        this.attributeCompanyLocale('designation'),
      ],
      ['titleLevel'],
    );
  }

  static get allAttributes() {
    return [
      new AT.EnumerationAttribute({
        name: 'classificationType',
        column: 'classification_type',
        enumType: 'RESOURCE_CLASSIFICATION',
        enumClass: HitOnlineEnums,
        tableProperties: {
          header: 'hit-base.common.type',
          maxWidth: '0.5fr',
        },
      }),
      this.NUMBER_ATTRIBUTE({}, {maxWidth: '1fr'}),
      new AT.IntegerAttribute({
        name: 'titleLevel',
        column: 'title_level',
      }),
    ].concat(
      this.generateMultiLanguageField({
        key: 'designation',
        attributeClass: AT.StringAttribute,
        header: 'hit-base.common.designation',
      }),
    );
  }
}
